import * as yup from 'yup'

import {
  Button,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Table,
} from 'reactstrap'
import { FaPencilAlt, FaSave, FaTrash } from 'react-icons/fa'
import React, { useState } from 'react'

import BuscadorTablas from 'components/Buscador/BuscadorTabla'
import PaginaPorDefecto from './Default'
import TarjetaContenido from 'components/TarjetaContenido/TarjetaContenido'
import { useDimension } from 'hooks/useDimension'
import { useFactor } from 'hooks/useFactor'
import { useFormik } from 'formik'
import { useToggle } from 'hooks/useToggle'
import uuid from 'uuid/v4'

const initialValues = {
  identificador: '',
  nombre: '',
  descripcion: '',
  peso: '',
  dimension: '',
}

const factorSchema = yup.object().shape({
  identificador: yup.string().required('Este campo es requerido'),
  nombre: yup.string().required('Este campo es requerido'),
  descripcion: yup.string().required('Este campo es requerido'),
  peso: yup.string().required('Este campo es requerido'),
  dimension: yup.string().required('Este campo es requerido'),
})

export default function Factor() {
  const { open, onToggle } = useToggle()
  const [factorEdit, setFactorEdit] = useState(null)
  const [buscar, setBuscar] = useState('')
  const {
    obtenerFactores,
    handleEliminarFactor,
    handleActualizarFactor,
    handleCrearFactor,
    handleBuscarFactor,
  } = useFactor(onToggle)
  const { obtenerDimensiones } = useDimension(onToggle)
  const { data: dimensiones } = obtenerDimensiones(buscar)
  const { data: factores } = obtenerFactores(buscar)

  const { handleChange, values, handleSubmit, errors } = useFormik({
    enableReinitialize: true,
    validationSchema: factorSchema,
    initialValues: {
      ...initialValues,
      ...factorEdit,
    },
    onSubmit: async (values, acciones) => {
      if (factorEdit) {
        handleActualizarFactor({ values, acciones, id: factorEdit.id })
      } else {
        handleCrearFactor(values, acciones)
      }
    },
  })

  const onClosedModal = () => {
    setFactorEdit(null)
  }

  return (
    <PaginaPorDefecto titulo='Factor'>
      <Modal
        isOpen={open}
        toggle={onToggle}
        size='lg'
        unmountOnClose
        onClosed={onClosedModal}
      >
        <ModalHeader toggle={onToggle}>
          {factorEdit ? 'Editar' : 'Crear'} Factor
        </ModalHeader>
        <ModalBody>
          <form className='form-horizontal col-xs-12' onSubmit={handleSubmit}>
            <FormGroup>
              <Label>Identificador</Label>
              <Input
                type='text'
                name='identificador'
                value={values.identificador}
                onChange={handleChange}
                placeholder='Ingrese identificador'
                invalid={!!errors.identificador}
              />
              <div className='invalid-feedback'>{errors.identificador}</div>
            </FormGroup>

            <FormGroup>
              <Label>Nombre</Label>
              <Input
                type='text'
                name='nombre'
                value={values.nombre}
                onChange={handleChange}
                placeholder='Ingrese nombre'
                invalid={!!errors.nombre}
              />
              <div className='invalid-feedback'>{errors.nombre}</div>
            </FormGroup>

            <FormGroup>
              <Label>Descripción</Label>
              <Input
                type='textarea'
                name='descripcion'
                value={values.descripcion}
                onChange={handleChange}
                placeholder='Ingrese descripción'
                invalid={!!errors.descripcion}
              />
              <div className='invalid-feedback'>{errors.descripcion}</div>
            </FormGroup>

            <FormGroup>
              <Label>Peso</Label>
              <Input
                type='number'
                name='peso'
                value={values.peso}
                onChange={handleChange}
                placeholder='Ingrese peso'
                invalid={!!errors.peso}
              />
              <div className='invalid-feedback'>{errors.peso}</div>
            </FormGroup>

            <FormGroup>
              <Label>Dimensión</Label>
              <Input
                type='select'
                name='dimension'
                value={values.dimension}
                onChange={handleChange}
                placeholder='Ingrese dimension'
                invalid={!!errors.dimension}
              >
                <option value=''>Seleccione...</option>
                {dimensiones?.results.map((dimension) => (
                  <option key={uuid()} value={dimension.id}>
                    {dimension.nombre}
                  </option>
                ))}
              </Input>
              <div className='invalid-feedback'>{errors.dimension}</div>
            </FormGroup>

            <div className='form-group'>
              <label
                className='col-md-12 control-label'
                htmlFor='singlebutton'
              ></label>
              <div className='col-md-12'>
                <Button className='mb-3' color='primary' type='submit'>
                  {factorEdit ? 'Editar' : 'Guardar'}
                </Button>
              </div>
            </div>
          </form>
        </ModalBody>
      </Modal>

      <TarjetaContenido
        titulo='Listar Factor'
        component={
          <Button outline color='primary' onClick={onToggle}>
            <FaSave />
          </Button>
        }
      >
        <BuscadorTablas
          valor={buscar}
          onChange={setBuscar}
          onBuscar={handleBuscarFactor}
        />
        {factores ? (
          <Table responsive>
            <thead>
              <tr>
                <th>#</th>
                <th>Identificador</th>
                <th>Nombre</th>
                <th>Descripción</th>
                <th>Peso</th>
                <th>Dimensión</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {factores.results.map((factor, index) => (
                <tr key={uuid()}>
                  <th scope='row'>{index + 1}</th>
                  <td>{factor.identificador}</td>
                  <td>{factor.nombre}</td>
                  <td>{factor.descripcion}</td>
                  <td>{factor.peso}</td>
                  <td>{factor.dimension__nombre}</td>
                  <td className='d-flex'>
                    <Button
                      outline
                      color='primary'
                      size='sm'
                      className='mr-1'
                      onClick={() => {
                        setFactorEdit(factor)
                        onToggle()
                      }}
                    >
                      <FaPencilAlt />
                    </Button>{' '}
                    <Button
                      outline
                      color='danger'
                      size='sm'
                      onClick={() => handleEliminarFactor(factor)}
                    >
                      <FaTrash />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          <div>Loading...</div>
        )}
      </TarjetaContenido>
    </PaginaPorDefecto>
  )
}
